import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from '../axiosConfig';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import Resizer from 'react-image-file-resizer';
import { motion } from 'framer-motion';


function BackgroundVerification() {
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const [document, setDocument] = useState({});

  const [documentData, setDocumentData] = useState({
    first_name: '',
    middle_name: '',
    last_name: '',
  father: {
    father_first_name: '',
    father_middle_name: '',
    father_last_name: '',
    },
    dob: '',
    gender: '',
    profile: null,
    contact_number: '',
    employee_code: '',
  });

  const [verifying, setVerifying] = useState({
    pan: false,
    aadhaar: false,
    drivingLicense: false,
    uan: false,
    voter: false,
    passport: false,
    bank: false
  });


  const [drivingLicenseDob, setDrivingLicenseDob] = useState('');
  const [passportDob, setPassportDob] = useState('');
  const [profileFile, setProfileFile] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [faceMatchSuccess, setFaceMatchSuccess] = useState(false);
  const [panNumber, setPanNumber] = useState('');
    const [documents, setDocuments] = useState([]);
    const [currentDocumentId, setCurrentDocumentId] = useState(null);
    const [documentTypes, setDocumentTypes] = useState({});
    const [uploadTypes, setUploadTypes] = useState({});
    const [currentUser, setCurrentUser ] = useState(null);
    const [ imageId, setImageId ] = useState ('');
    const navigate = useNavigate();
    const [digilockerAuthUrl, setDigilockerAuthUrl] = useState(null);
const [digilockerLoading, setDigilockerLoading] = useState(false);
const [aadhaarLoading, setAadhaarLoading] = useState(false);
 const [activePath, setActivePath] = useState('');
    const [departments, setDepartments] = useState([]);
      const [departmentsOpen, setDepartmentsOpen] = useState(false);
      const location = useLocation();

    useEffect(() => setActivePath(location.pathname), [location]);

  const handleDocChange = (e) => {
    const { name, value } = e.target;
    if (value === '') {
      setDocument((prevDocument) => ({ ...prevDocument, [name]: null }));
    } else {
      setDocument((prevDocument) => ({ ...prevDocument, [name]: value }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'document_id') {
      setDocumentData((prevData) => ({ ...prevData, document_id: value }));
    } else if (name === 'passport_dob') {
      setPassportDob(value);
      setDocumentData((prevData) => ({ ...prevData, passport: { ...prevData.passport, dob: value } }));
    } else if (name === 'driving_license_dob') {
      setDrivingLicenseDob(value);
    } else {
      setDocumentData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  useEffect(() => {
    axiosInstance.get(`/documents/${selectedDocumentId}/`)
      .then(response => {
        setDocument(response.data);
      })
      .catch(error => {
        console.error('Error fetching document details:', error);
      });
  }, [id]);

  useEffect(() => {

      axiosInstance.get('/upload-documents/')
  .then(response => {
    const uploadDocuments = response.data;
    const image = uploadDocuments.find((document) => document.document === currentDocumentId);
    if (image) {
      setImageId(image.id);
    } else {
      setImageId(null);
    }
  })
  .catch(error => {
    console.error(error);
  });

  axiosInstance.get('/document-types/')
    .then(response => {
      setDocumentTypes(response.data);
    })
    .catch(error => {
      console.error(error);
    });

    axiosInstance.get('/document-images/')
    .then(response => {
      setUploadTypes(response.data);
    })
    .catch(error => {
      console.error(error);
    });


    

    const userId = localStorage.getItem('id');
    if (userId) {
      axiosInstance.get(`/user/${userId}/`)
        .then(response => {
          setCurrentUser (response.data);
        })
        .catch(error => {
          console.error("Error fetching user details:", error);
        });
    }
  }, []);


  const handlePanVerification = async () => {
    if (panNumber === '') {
      alert('Please enter a PAN number to verify');
      return;
    }
  
    setVerifying((prevVerifying) => ({ ...prevVerifying, pan: true }));
  
    try {
      const documentId = localStorage.getItem('selectedDocumentId');
      if (!documentId) {
        alert('No document ID found in local storage');
        return;
      }
  
      const response = await axiosInstance.post('/pan-update/', {
        pan_id: panNumber,
        name: [document.first_name, document.middle_name, document.last_name].filter(Boolean).join(' '),
        date_of_birth: document.date_of_birth,
        document_id: documentId,
      });
  
      console.log(response);
  
      if (response.status === 200) {
        const panAdvancedData = response.data.pan_advanced;
      
        alert(
          `PAN verification completed successfully\n\nDetails:\n` +
          `${typeof panAdvancedData === 'object'
            ? JSON.stringify(panAdvancedData, null, 2)
            : panAdvancedData}`
        );
      
        setVerifying((prevVerifying) => ({ ...prevVerifying, pan: false, panSuccess: true }));
      } else {
        alert('PAN verification failed');
        setVerifying((prevVerifying) => ({ ...prevVerifying, pan: false }));
      }
      
  
      setVerifying((prevVerifying) => ({ ...prevVerifying, pan: false, panSuccess: true }));
    } catch (error) {
      console.error('There was an error verifying the PAN', error);
      alert(`Error: ${error?.response?.data?.error || 'Something went wrong'}`);
      setVerifying((prevVerifying) => ({ ...prevVerifying, pan: false }));
    }
  };
  
  
  const handleAadhaarVerification = async () => {
    setVerifying((prevVerifying) => ({ ...prevVerifying, aadhaar: true }));
  
    try {
      const documentId = localStorage.getItem('selectedDocumentId');
      if (!documentId) {
        alert('No document ID found in local storage');
        return;
      }
  
      const response = await axiosInstance.post('/verify-aadhaar/', {
        aadhaar_number: documentData.aadhaar_verification,
        document_id: documentId,
      });
  
      console.log(response);
  
      if (response.status === 201 || response.status === 200) {
        let aadhaarRaw = response.data.aadhaar_verification;
        let aadhaarParsed;
  
        try {
          aadhaarParsed = JSON.parse(aadhaarRaw.replace(/'/g, '"'));
        } catch (parseError) {
          console.error("Failed to parse Aadhaar response", parseError);
          aadhaarParsed = { message: 'Could not parse Aadhaar details.' };
        }
  
        alert(`Aadhaar verification completed successfully\n\nMessage: ${aadhaarParsed.message}`);
  
        setVerifying((prevVerifying) => ({
          ...prevVerifying,
          aadhaar: false,
          aadhaarSuccess: true,
        }));
      } else {
        alert('Aadhaar verification failed');
        if (response.data?.error) {
          alert(`Error: ${response.data.error}`);
        }
        setVerifying((prevVerifying) => ({
          ...prevVerifying,
          aadhaar: false,
        }));
      }
    } catch (error) {
      console.error('There was an error verifying the Aadhaar', error);
      alert(`Error: ${error?.response?.data?.error || 'Something went wrong'}`);
      setVerifying((prevVerifying) => ({ ...prevVerifying, aadhaar: false }));
    }
  };
  
  
const handleDrivingLicenseVerification = async () => {
  setVerifying((prevVerifying) => ({ ...prevVerifying, drivingLicense: true }));
  try {
    const documentId = localStorage.getItem('selectedDocumentId');
    if (!documentId) {
      alert('No document ID found in local storage');
      return;
    }
    const response = await axiosInstance.post('/driving-license-update/', {
      driving_license_number: documentData.driving_license,
      dob: drivingLicenseDob,
      document_id: documentId,
    });
    console.log(response);
    if (response.status === 201 || response.status === 200) {
      if (response.data.driving_license_details) {
        const drivingLicenseData = JSON.parse(response.data.driving_license_details);
        if (drivingLicenseData.data.license_number) {
          setDocumentData((prevData) => ({ ...prevData, driving_license: drivingLicenseData.data.license_number }));
        }
      }
      alert('Driving License verification completed successfully');
    } else {
      alert('Driving License verification failed');
      if (response.data && response.data.error) {
        alert(`Error: ${response.data.error}`);
      }
    }
    setVerifying((prevVerifying) => ({ ...prevVerifying, drivingLicense: false, drivingLicenseSuccess: true }));
  } catch (error) {
    console.error('There was an error verifying the Driving License', error);
    alert(`Error: ${error.response.data.error}`);
    setVerifying((prevVerifying) => ({ ...prevVerifying, drivingLicense: false }));
  }
};

const handleBankAccountVerification = async () => {
  setVerifying((prevVerifying) => ({ ...prevVerifying, bank: true }));

  try {
    const documentId = localStorage.getItem('selectedDocumentId');
    if (!documentId) {
      alert('No document ID found in local storage');
      return;
    }

    const response = await axiosInstance.post('/bank-account-update/', {
      account_number: documentData.bank_account,
      ifsc_code: documentData.ifsc_code,
      document_id: documentId,
    });

    console.log(response);

    if (response.status === 201 || response.status === 200) {
      let bankRaw = response.data.verify_bank_account;
      let bankParsed;

      try {
        bankParsed = JSON.parse(bankRaw);
      } catch (parseError) {
        console.error("Failed to parse bank verification response", parseError);
        bankParsed = { data: { message: 'Could not parse verification result.' } };
      }

      const message = bankParsed?.data?.message || 'Bank verification completed.';
      alert(`Bank Account verification completed successfully\n\nMessage: ${message}`);

      setVerifying((prevVerifying) => ({
        ...prevVerifying,
        bank: false,
        bankSuccess: true,
      }));
    } else {
      alert('Bank Account verification failed');
      if (response.data?.error) {
        alert(`Error: ${response.data.error}`);
      }
      setVerifying((prevVerifying) => ({
        ...prevVerifying,
        bank: false,
      }));
    }
  } catch (error) {
    console.error('There was an error verifying the Bank Account', error);
    alert(`Error: ${error?.response?.data?.error || error.message}`);
    setVerifying((prevVerifying) => ({ ...prevVerifying, bank: false }));
  }
};

  
  const handleUanVerification = async () => {
    setVerifying((prevVerifying) => ({ ...prevVerifying, uan: true }));
    try {
      const documentId = localStorage.getItem('selectedDocumentId');
      if (!documentId) {
        alert('No document ID found in local storage');
        return;
      }
      const response = await axiosInstance.post('/uan-update/', {
        mobile_number: documentData.contact_number, 
        document_id: documentId,
      });
      console.log(response);
      if (response.status === 201 || response.status === 200) {
        const uanData = JSON.parse(response.data.get_uan);
        const message = `UAN verification completed successfully.
          Message: ${uanData.data.message}`;
        alert(message);
      } else {
        alert('UAN verification failed');
        if (response.data && response.data.error) {
          alert(`Error: ${response.data.error}`);
        }
      }
      setVerifying((prevVerifying) => ({ ...prevVerifying, uan: false, uanSuccess: true }));
    } catch (error) {
      console.error('There was an error verifying the UAN', error);
      alert(`Error: ${error.response.data.error}`);
      setVerifying((prevVerifying) => ({ ...prevVerifying, uan: false }));
    }
  };
  
  const handleVoterVerification = async () => {
    setVerifying((prevVerifying) => ({ ...prevVerifying, voter: true }));
    try {
        const documentId = localStorage.getItem('selectedDocumentId');
    if (!documentId) {
      alert('No document ID found in local storage');
      return;
    }
      const response = await axiosInstance.post('/voter-id-update/', {
        voter_id: documentData.voter_id,
        document_id: documentId,
      });
      console.log(response);
      if (response.status === 201 || response.status === 200) {
        if (response.data.voter_details) {
          const voterData = JSON.parse(response.data.voter_details);
          if (voterData.voter_id) {
            setDocumentData((prevData) => ({ ...prevData, voter_id: voterData.voter_id }));
          }
        }
        alert('Voter verification completed successfully');
      } else {
        alert('Voter verification failed');
        if (response.data && response.data.error) {
          alert(`Error: ${response.data.error}`);
        }
      }
      setVerifying((prevVerifying) => ({ ...prevVerifying, voter: false, voterSuccess: true }));
    } catch (error) {
      console.error('There was an error verifying the Voter', error);
      alert(`Error: ${error.response.data.error}`);
      setVerifying((prevVerifying) => ({ ...prevVerifying, voter: false }));
    }
  };
  
  const handlePassportVerification = async () => {
    setVerifying((prevVerifying) => ({ ...prevVerifying, passport: true }));
  
    try {
      const documentId = localStorage.getItem('selectedDocumentId');
      if (!documentId) {
        alert('No document ID found in local storage');
        return;
      }
  
      const response = await axiosInstance.post('/passport-update/', {
        passport_number: documentData.passportIdNumber,
        dob: passportDob,
        document_id: documentId,
      });
  
      console.log(response);
  
      let message = 'Passport verification completed.';
      if (response.status === 201 || response.status === 200) {
        let passportRaw = response.data.verify_passport;
        let passportParsed;
  
        try {
          passportParsed = JSON.parse(passportRaw);
          message = passportParsed?.data?.message || message;
        } catch (parseError) {
          console.error("Failed to parse passport verification data", parseError);
          message = 'Passport verification completed (could not parse message).';
        }
  
        if (response.data.passport_details) {
          const passportDetails = JSON.parse(response.data.passport_details);
          if (passportDetails?.data?.file_number) {
            setDocumentData((prevData) => ({
              ...prevData,
              passportIdNumber: passportDetails.data.file_number
            }));
          }
        }
  
        alert(`Passport verification completed successfully\n\nMessage: ${message}`);
        setVerifying((prevVerifying) => ({
          ...prevVerifying,
          passport: false,
          passportSuccess: true,
        }));
      } else {
        alert('Passport verification failed');
        if (response.data?.error) {
          alert(`Error: ${response.data.error}`);
        }
        setVerifying((prevVerifying) => ({ ...prevVerifying, passport: false }));
      }
    } catch (error) {
      console.error('There was an error verifying the Passport', error);
      alert(`Error: ${error?.response?.data?.error || error.message}`);
      setVerifying((prevVerifying) => ({ ...prevVerifying, passport: false }));
    }
  };
  

  const fetchPanNumber = async () => {
    try {
        const documentId = localStorage.getItem('selectedDocumentId');
        if (!documentId) {
          alert('No document ID found in local storage');
          return;
        }
      const response = await axiosInstance.get(`/pan/${documentId}/`);
      const panData = eval('(' + response.data.pan_number + ')');
      setPanNumber(panData.number);
    } catch (error) {
      console.error('Error fetching PAN number:', error);
    }
  };

  useEffect(() => {
    fetchPanNumber();
  }, [id]);
  
  const fetchAadhaar = async () => {
    try {
      const response = await axiosInstance.get(`/aadhaar-details/${id}/`);
      const aadhaarData = eval('(' + response.data.aadhaar_details + ')');
      setDocumentData((prevData) => ({ ...prevData, aadhaar_verification: aadhaarData.aadhaar_number }));
    } catch (error) {
      console.error('Error fetching Aadhaar number:', error);
    }
  };
  
  useEffect(() => {
    fetchAadhaar();
  }, [id]);

  const fetchDrivingLicense = async () => {
    try {
      const response = await axiosInstance.get(`/driving-license-details/${id}/`);
      if (response.data.driving_license_details) {
        const drivingLicenseData = JSON.parse(response.data.driving_license_details);
        if (drivingLicenseData.data.license_number) {
          setDocumentData((prevData) => ({ ...prevData, driving_license: drivingLicenseData.data.license_number }));
        }
      }
    } catch (error) {
      console.error('Error fetching Driving License number:', error);
    }
  };
  
  useEffect(() => {
    fetchDrivingLicense();
  }, [id]);

  const fetchVoter = async () => {
    try {
      const response = await axiosInstance.get(`/voter-details/${id}/`);
      if (response.data.voter_details) {
        const voterData = JSON.parse(response.data.voter_details);
        if (voterData.data.epic_no) {
          setDocumentData((prevData) => ({ ...prevData, voter_id: voterData.data.epic_no }));
        }
      }
    } catch (error) {
      console.error('Error fetching Voter ID:', error);
    }
  };
  
  useEffect(() => {
    fetchVoter();
  }, [id]);

  const fetchPassport = async () => {
    try {
      const response = await axiosInstance.get(`/passport-details/${id}/`);
      if (response.data.passport_details) {
        const passportData = JSON.parse(response.data.passport_details);
        if (passportData.data.file_number) {
          setDocumentData((prevData) => ({ ...prevData, passportIdNumber: passportData.data.file_number }));
        }
      }
    } catch (error) {
      console.error('Error fetching Passport number:', error);
    }
  };

  useEffect(() => {
    fetchPassport();
  }, [id]);

  const handleDateChange = (e) => {
    const { value } = e.target;
    const formattedDate = new Date(value).toISOString().split('T')[0]; 
    setDocument((prevDocument) => ({
      ...prevDocument,
      dob: formattedDate,
    }));
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setProfileFile(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    
    Object.keys(document).forEach((key) => {
      if (key !== "profile") {
        formData.append(key, document[key]);
      }
    });
  
    if (fileInputRef.current && fileInputRef.current.files[0]) {
      formData.append("profile", fileInputRef.current.files[0]);
    }
  
    axiosInstance
      .put(`/documents/${id}/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log("Document updated successfully:", response.data);
        alert("Document updated successfully!");
      })
      .catch((error) => {
        console.error("Error updating document:", error);
      });
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        800, 
        600,
        'JPEG', 
        80, 
        0, 
        (uri) => {
          
          fetch(uri)
            .then((res) => res.blob())
            .then((blob) => {
              const resizedFile = new File([blob], file.name, { type: blob.type });
              resolve(resizedFile);
            });
        },
        'base64'
      );
    });

  const handleFaceChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const resizedImage = await resizeFile(file);
        console.log("Captured file:", resizedImage);
  
        if (event.target.name === 'file1') {
          setFile1(resizedImage);
        } else if (event.target.name === 'file2') {
          setFile2(resizedImage);
        }
      } catch (err) {
        setError("Error resizing the image");
        console.error(err);
      }
    }
  };
  const handleFaceSubmit = (event) => {
    event.preventDefault();
  
    const formData = new FormData();
    formData.append('file_1', file1);
    formData.append('file_2', file2);
  
    const documentId = localStorage.getItem('selectedDocumentId');
    if (!documentId) {
      alert('No document ID found in local storage');
      return;
    }
    formData.append('document_id', documentId);
  
    axiosInstance.post('face-match/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        setResponse(response.data);
        setFaceMatchSuccess(true);
  
        const faceMessage = response.data?.face_match || 'Face match result not found.';
        alert(`Face Match Result: ${faceMessage}`);
      })
      .catch((error) => {
        console.error("Face match error", error);
        setError(error.response?.data?.error || 'An unknown error occurred.');
        alert(`Error: ${error.response?.data?.error || error.message}`);
      });
  };
  


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen); 
  };

  const selectedDocumentId = Number(localStorage.getItem('selectedDocumentId'));

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const photoDoc = Array.isArray(uploadTypes)
  ? uploadTypes.find(doc => doc.document === selectedDocumentId && doc.document_type_info === 'KYC - Photo')
  : null;


  const photoUrl = photoDoc ? photoDoc.file : null;

  const verifyDocument = async (selectedDocumentId) => {
    try {
      const response = await axiosInstance.post(`/documents/verify/${selectedDocumentId}/`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        throw new Error(error.response.data.error);
      } else {
        throw new Error(error.message || 'Unknown error occurred');
      }
    }
  };
  
  const initDigiLocker = async () => {
    setDigilockerLoading(true);
    try {
      const response = await axiosInstance.get("/digilocker/init/");
      const data = response.data;
  
      console.log("DigiLocker Init:", data);
  
      // Save transaction_id in localStorage
      if (data.data && data.data.transaction_id) {
        localStorage.setItem("digilocker_transaction_id", data.data.transaction_id);
      }
  
      // Set authorization URL for button
      if (data.data && data.data.authorization_url) {
        setDigilockerAuthUrl(data.data.authorization_url);
      } else {
        alert("Authorization URL not received");
      }
    } catch (error) {
      console.error("DigiLocker Init Error:", error);
      alert("Error initializing DigiLocker. Check console for details.");
    } finally {
      setDigilockerLoading(false);
    }
  };
  

  const fetchEAadhaar = async (selectedDocumentId) => {
    setAadhaarLoading(true);
  
    try {
      const transactionId = localStorage.getItem("digilocker_transaction_id");
  
      if (!transactionId) {
        alert("Please initialize DigiLocker first.");
        setAadhaarLoading(false);
        return;
      }
  
      if (!window.confirm("Have you completed DigiLocker authorization?")) {
        alert("Please authorize via 'Go to DigiLocker Authorization' before fetching eAadhaar.");
        setAadhaarLoading(false);
        return;
      }
  
      const response = await axiosInstance.post("/digilocker/eaadhaar/", {
        document_id: selectedDocumentId,
        transaction_id: transactionId,
      });
  
      console.log("eAadhaar Response:", response.data);
      alert("eAadhaar fetched successfully!");
  
    } catch (error) {
      console.error("Error fetching eAadhaar:", error);
      alert("Error fetching eAadhaar. Make sure you have authorized the transaction.");
    } finally {
      setAadhaarLoading(false);
    }
  };
  
  

  return (
      <div className="dashboard-wrapper">
              {/* Left Sidebar */}
              <div className="dashboard-sidebar">
      <div className="sidebar-header">
        <img src="/logo.png" alt="Logo" className="sidebar-logo" />
      </div>
    
      <nav className="sidebar-nav">
        <Link
          to="/admin-dashboard"
          className={`sidebar-link ${activePath === '/admin-dashboard' ? 'active' : ''}`}
        >
          <i className="fas fa-home"></i> Dashboard
        </Link>
    
        {currentUser?.role_name === 'admin' && (
          <Link
            to="/users"
            className={`sidebar-link ${activePath === '/users' ? 'active' : ''}`}
          >
            <i className="fas fa-users"></i> Users
          </Link>
        )}
    
        {/* Simplified Departments Link */}
        <Link
          to="/departments"
          className={`sidebar-link ${activePath === '/departments' ? 'active' : ''}`}
        >
          <i className="fas fa-file-alt"></i> Departments
        </Link>
      </nav>
    </div>

    <div
            className="dashboard-main"
            style={{
              display: 'flex',
              gap: '20px',
              flexWrap: 'nowrap',
              alignItems: 'flex-start',
              padding: '20px',
            }}
          >
             <div className="dashboard-bgv" style={{ flex: 3 }}>
            
            <h2>BackGround Verification</h2>
            <div
                        className="dashboard-cards"
                        style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}
                      >
                        </div>
                     
    
                        <div className="dashboard-cards" style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
</div>

<form onSubmit={handleSubmit} className="form-wrapper">
  {/* ===== PERSONAL INFO ===== */}
  <fieldset className="personal-info-section">
  <legend>Personal Information</legend>

  <div className="personal-info-grid">
    {/* Left Side: Details */}
    <div className="personal-info-details">
      <div className="info-row">
        <div className="info-field">
          <label>Employee Code</label>
          <input type="text" value={document.employee_code} readOnly />
        </div>
        <div className="info-field">
          <label>Contact Number</label>
          <input type="text" value={document.contact_number} readOnly />
        </div>
      </div>

      <div className="info-row">
        <div className="info-field">
          <label>First Name</label>
          <input type="text" value={document.first_name} readOnly />
        </div>
        <div className="info-field">
          <label>Middle Name</label>
          <input type="text" value={document.middle_name} readOnly />
        </div>
        <div className="info-field">
          <label>Last Name</label>
          <input type="text" value={document.last_name} readOnly />
        </div>
      </div>

      <div className="info-row">
        <div className="info-field">
          <label>Father’s First Name</label>
          <input type="text" value={document.father_first_name || ''} readOnly />
        </div>
        <div className="info-field">
          <label>Father’s Middle Name</label>
          <input type="text" value={document.father_middle_name || ''} readOnly />
        </div>
        <div className="info-field">
          <label>Father’s Last Name</label>
          <input type="text" value={document.father_last_name || ''} readOnly />
        </div>
      </div>

      <div className="info-row">
        <div className="info-field">
          <label>Date of Birth</label>
          <input type="date" value={document.date_of_birth} readOnly />
        </div>
        <div className="info-field">
          <label>Gender</label>
          <input type="text" value={document.gender || ''} readOnly />
        </div>
      </div>
    </div>

    {/* Right Side: Photo */}
    <div className="personal-photo">
      {photoUrl ? (
        <img src={photoUrl} alt="Document Photo" />
      ) : (
        <div className="upload-placeholder">No Photo Available</div>
      )}
    </div>
  </div>
</fieldset>

  <hr />

{/* === PAN Verification === */}
<div className='all-verify'>
<fieldset className="verify-section">
  <legend>PAN Verification</legend>
  <div className="verify-row">
    <div className="verify-input">
      <label>PAN *</label>
      <input
        type="text"
        name="pan_advanced"
        value={panNumber}
        maxLength={10}
        onChange={(e) => {
          let value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
          setPanNumber(value);
        }}
        placeholder="ABCDE1234F"
      />
    </div>
    <button
      className={`verify-btn ${verifying.pan ? 'verifying' : ''} ${verifying.panSuccess ? 'success' : ''}`}
      type="button"
      onClick={handlePanVerification}
    >
      {verifying.pan ? 'Verifying...' : verifying.panSuccess ? 'Verified' : 'Verify'}
    </button>
  </div>
</fieldset>

{/* === Aadhaar Verification === */}
<fieldset className="verify-section">
  <legend>Aadhaar Verification</legend>
  <div className="verify-row">
    <div className="verify-input">
      <label>DigiLocker</label>
      <button
        className="verify-btn"
        onClick={initDigiLocker}
        disabled={digilockerLoading}
        type="button"
      >
        {digilockerLoading ? 'Initializing...' : 'Init DigiLocker'}
      </button>
    </div>

    {digilockerAuthUrl && (
      <button
        className="verify-btn"
        type="button"
        onClick={() => window.open(digilockerAuthUrl, "_blank")}
      >
        Go to Authorization
      </button>
    )}

    <button
      className="verify-btn"
      onClick={() => fetchEAadhaar(selectedDocumentId)}
      disabled={aadhaarLoading}
      type="button"
    >
      {aadhaarLoading ? 'Fetching...' : 'Fetch eAadhaar'}
    </button>
  </div>
</fieldset>

{/* === Face Match Verification === */}
<fieldset className="verify-section">
  <legend>Face Match Verification</legend>
  <div className="verify-row">
    <div className="verify-input">
      <label>Photo File</label>
      <input type="file" name="file1" accept="image/*" onChange={handleFaceChange} />
    </div>
    <div className="verify-input">
      <label>ID File</label>
      <input type="file" name="file2" accept="image/*" onChange={handleFaceChange} />
    </div>
    <button
      className={`verify-btn ${faceMatchSuccess ? 'success' : ''}`}
      type="button"
      onClick={handleFaceSubmit}
    >
      {faceMatchSuccess ? 'Verified' : 'Verify'}
    </button>
  </div>
</fieldset>

{/* === Driving License Verification === */}
<fieldset className="verify-section">
  <legend>Driving License Verification</legend>
  <div className="verify-row">
    <div className="verify-input">
      <label>License No.</label>
      <input
        type="text"
        name="driving_license"
        value={documentData.driving_license}
        onChange={handleChange}
      />
    </div>
    <div className="verify-input">
      <label>Date of Birth</label>
      <input
        type="date"
        name="driving_license_dob"
        onChange={handleChange}
      />
    </div>
    <button
      className={`verify-btn ${verifying.drivingLicense ? 'verifying' : ''} ${verifying.drivingLicenseSuccess ? 'success' : ''}`}
      type="button"
      onClick={handleDrivingLicenseVerification}
    >
      {verifying.drivingLicense ? 'Verifying...' : verifying.drivingLicenseSuccess ? 'Verified' : 'Verify'}
    </button>
  </div>
</fieldset>

{/* === Bank Verification === */}
<fieldset className="verify-section">
  <legend>Bank Account Verification</legend>
  <div className="verify-row">
    <div className="verify-input">
      <label>Account No.</label>
      <input
        type="text"
        name="bank_account"
        value={documentData.bank_account}
        onChange={handleChange}
        placeholder="Account No."
      />
    </div>
    <div className="verify-input">
      <label>IFSC</label>
      <input
        type="text"
        name="ifsc_code"
        value={documentData.ifsc_code}
        onChange={handleChange}
        placeholder="IFSC Code"
      />
    </div>
    <button
      className={`verify-btn ${verifying.bank ? 'verifying' : ''} ${verifying.bankSuccess ? 'success' : ''}`}
      type="button"
      onClick={handleBankAccountVerification}
    >
      {verifying.bank ? 'Verifying...' : verifying.bankSuccess ? 'Verified' : 'Verify'}
    </button>
  </div>
</fieldset>

{/* === UAN Verification === */}
<fieldset className="verify-section">
  <legend>UAN Verification</legend>
  <div className="verify-row">
    <div className="verify-input">
      <label>UAN</label>
      <input
        type="text"
        name="contact_number"
        value={documentData.contact_number || ''}
        onChange={handleChange}
        placeholder="UAN Number"
      />
    </div>
    <button
      className={`verify-btn ${verifying.uan ? 'verifying' : ''} ${verifying.uanSuccess ? 'success' : ''}`}
      type="button"
      onClick={handleUanVerification}
    >
      {verifying.uan ? 'Verifying...' : verifying.uanSuccess ? 'Verified' : 'Verify'}
    </button>
  </div>
</fieldset>

{/* === Voter ID Verification === */}
<fieldset className="verify-section">
  <legend>Voter ID Verification</legend>
  <div className="verify-row">
    <div className="verify-input">
      <label>Voter ID</label>
      <input
        type="text"
        name="voter_id"
        value={documentData.voter_id}
        onChange={handleChange}
      />
    </div>
    <button
      className={`verify-btn ${verifying.voter ? 'verifying' : ''} ${verifying.voterSuccess ? 'success' : ''}`}
      type="button"
      onClick={handleVoterVerification}
    >
      {verifying.voter ? 'Verifying...' : verifying.voterSuccess ? 'Verified' : 'Verify'}
    </button>
  </div>
</fieldset>

{/* === Passport Verification === */}
<fieldset className="verify-section">
  <legend>Passport Verification</legend>
  <div className="verify-row">
    <div className="verify-input">
      <label>File No.</label>
      <input
        type="text"
        name="passportIdNumber"
        value={documentData.passportIdNumber}
        onChange={handleChange}
        placeholder="File No."
      />
    </div>
    <div className="verify-input">
      <label>Date of Birth</label>
      <input
        type="date"
        name="passport_dob"
        onChange={handleChange}
      />
    </div>
    <button
      className={`verify-btn ${verifying.passport ? 'verifying' : ''} ${verifying.passportSuccess ? 'success' : ''}`}
      type="button"
      onClick={handlePassportVerification}
    >
      {verifying.passport ? 'Verifying...' : verifying.passportSuccess ? 'Verified' : 'Verify'}
    </button>
  </div>
</fieldset>
</div>

  {/* ===== SUBMIT ===== */}
  <button
    type="button"
    className="submit-all-btn"
    onClick={async () => {
      try {
        await verifyDocument(document.id);
        navigate('/documents');
      } catch (err) {
        alert(err.message);
      }
    }}
  >
    Submit
  </button>
</form>

      </div>
      </div>
      </div>
  );
}

export default BackgroundVerification;